var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.config.border.show)?_c('div',{staticClass:"borderChart"},[(_vm.config.border.index==='自定义')?_c('div',{style:({
        'border-width': ((_vm.config.border.width) + "px"),
        'border-style': ("" + (_vm.config.border.style)),
        'border-color': ("" + (_vm.config.border.color)),
        'border-radius': ((_vm.config.border.radius) + "px"),
        'border-image-slice': '100',
    })}):_c('div',{style:({
        'border-image-source': ("url('" + (_vm.list[_vm.config.border.index].img) + "')"),
        'border-width': ((_vm.config.border.width) + "px"),
        'border-image-slice': '100',
        'border-style': 'solid'
    })})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }